import type { Drawing } from "building-types/drawings/drawingTypes";
import { DrawingId, DrawingType } from "building-types/drawings/drawingTypesEnum";
import type { DrawingRef } from "building-types/views/sheetsTypes";
import { drawingNew } from "./drawingTools";

export const defaultDrawingCatalog: { [K in DrawingId]: Drawing } = {
  [DrawingId.NONE]: drawingNew({
    id: DrawingId.NONE,
    type: DrawingType.VOID,
    name: "None",
    url: "",
    catalogId: "",
  }),
  [DrawingId.NULL]: drawingNew({
    id: DrawingId.NULL,
    type: DrawingType.VOID,
    name: "No Detail Assigned",
    catalogId: "",
  }),
};

export function mergeDrawingRefWithCatalogItem(drawingRef: DrawingRef, drawingFromCatalog: Drawing) {
  return {
    ...(drawingFromCatalog ?? {}),
    ...(drawingRef ?? {}),
  } as DrawingRef;
}
